<template>
  <div class="layout my-contacts">
    <div class="tab_nav">
      <div class="nav_item" :class="{ is_active: index == actIndex }" @click="tabChange(index)" v-for="(item, index) in navList" :key="index">
        {{ item }}
        <div :class="{ xian: index == actIndex }"></div>
      </div>
    </div>
    <div class="tab_content">
      <myIssue v-if="actIndex == 0"></myIssue>
      <myCollect v-if="actIndex == 1"></myCollect>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import myIssue from "./components/my-issue-topic"; //我发布的
import myCollect from "./components/my-collect-topic"; //我关注的
export default {
  name: "my-order",
  components: {
    myIssue,
    myCollect,
  },
  data() {
    return {
      actIndex: 0,
      navList: ["Business card", "No response"],
    };
  },
  async created() {
    this.$store.commit("setExhibitionId", this.$route.params.id);
    if (!this.userInfo) {
      await this.$Myapollo.getUserInfo(this);
    } 
    this.$Myapollo.addExhibitionView();
    this.actIndex = this.myTopicHead;
  },
  mounted() {},
  computed: {
    ...mapGetters({
      myTopicHead: "getMyTopicHead",
      userInfo: "getUserInfo",
    }),
  },
  methods: {
    tabChange(i) {
      if (this.actIndex == i) {
        return;
      }
      this.actIndex = i;
      this.$Myapollo.addExhibitionView();
      this.$store.commit("setMyTopicHead", i);
    },
  },
};
</script>

<style lang="scss" scoped>
.my-contacts {
  background: #f2f2f2;
  padding: 0.9rem 0 0;
  .tab_nav {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    height: 0.9rem;
    width: 100%;
    display: flex;
    z-index: 99;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.02rem;
    border-bottom: 1px solid #e6e6e6;
    .nav_item {
      color: #666;
      width: 2rem;
      height: 0.48rem;
      line-height: 0.48rem;
      text-align: center;
      border-radius: 0.48rem;
      font-size: 0.26rem;

      &.is_active {
        color: #1890ff;
        background: #fff;
      }
    }
    .xian {
      width: 0.54rem;
      height: 2px;
      background: #1890ff;
      margin: 0 auto;
    }
  }
  .tab_content {
    padding: 0.3rem;
  }
}
</style>
